// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"4c30b4f3","977":"690f8390"}[chunkId] + ".chunk.js";
};